import { useMemo, useState } from 'react';

import { filterOptionsByLabel } from './FilterSelectSearch';

export const useOptionSearch = <T extends { value: string; label: string }>(
  options: T[]
) => {
  const [searchTerm, setSearchTerm] = useState('');
  const visibleOptions = useMemo(
    () => filterOptionsByLabel(options, searchTerm),
    [options, searchTerm]
  );

  return { searchTerm, setSearchTerm, visibleOptions };
};
